export default __webpack_public_path__ + "static/media/Vector (Stroke2).75bf40fe.webp";